export default __webpack_public_path__ + "static/media/arab.1d9b4ed1.png";